import classNames from 'classnames';

import useClickableService from './clickable.service';
import { ClickableProps } from './clickable.types';

export const Clickable: React.FC<ClickableProps> = ({
  onLongPress,
  children,
  onClick,
  ...rest
}: ClickableProps) => {
  const cssClasses = classNames('clickable', rest.className);
  const { handlers } = useClickableService({ onLongPress, onClick });

  return (
    <div {...rest} className={cssClasses} {...handlers}>
      {children}
    </div>
  );
};
